/*
 * Copyright (c) Nexign, JSC, 2019-2022.
 */
/**
 *
 *
 * @author Evgenij Tyan
 * @author Yakov Gushchin
 * @version 1.19.0
 * @since 1.0.0
 */

import { Fragment, memo } from 'react';

import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { icons } from '../../../../../assets/index';
import { renderSettingButton } from '../../../../../components/common/PageTitle/PageTitle';
import { IPageSubscriberMobileTranslation } from '../../../../../modules/internationalization/types/index';
import { modalOpen } from '../../../../../modules/modal/modalActions';
import { IModalOpenPayload } from '../../../../../modules/modal/types/modalActionTypes';
import { IModalRenderProps } from '../../../../../modules/modal/types/modalTypes';
import { setExtFilterTabIndex } from '../actions/extFilterApiActions';
import ExtFilterPopup from './ExtFilterPopup/ExtFilterPopup';

interface IDispatchProps {
    openModal: (payload: IModalOpenPayload) => void;
    setExtFilterTabIndex: (payload?: number) => void;
}

/*
 * @property {IPageSubscriberMobileTranslation} translation - locale
 */
export interface ISubscriberMobileExtFilterProps {
    translation: IPageSubscriberMobileTranslation;
}

type ExtFilter = ISubscriberMobileExtFilterProps & IDispatchProps;

/* TODO: migrate to rtk */
/**
 * @description Subscriber external filter button
 * @interface ISubscriberMobileExtFilterProps
 */
const SubscriberMobileExtFilter = (props: ExtFilter) => {

    const openExtFitler = () => {
        props.openModal({
            render: (p: IModalRenderProps) => <ExtFilterPopup
                closeExtFilter={() => {
                    closeExtFilter();
                    p.onCloseModal();
                }}
                translation={props.translation.extFilter}/>,
        });
    };

    const closeExtFilter = () => {
        props.setExtFilterTabIndex();
    };

    return (
        <Fragment>
            {
                renderSettingButton(
                    {
                        className: 'page-title__block-with-icon',
                        dataName: 'ext-filter',
                        iconLeft: icons.filterNormalIcon,
                        id: 0,
                        onClick: openExtFitler,
                        value: props.translation.title.filterSetting,
                    },
                )
            }
        </Fragment>
    );
};
export const mapDispatchToProps = (dispatch: Dispatch): IDispatchProps => ({
    openModal: (payload: IModalOpenPayload) => dispatch(modalOpen(payload)),
    setExtFilterTabIndex: (payload?: number) => dispatch(setExtFilterTabIndex(payload)),
});

export default connect(null, mapDispatchToProps)(memo(SubscriberMobileExtFilter));
